import React from 'react';
import { Modal, message } from 'antd';
import RecordForm from '../../../components/RecordForm';
import dayjs from 'dayjs';

const CreateExpenseModal = ({ open, onClose, onCreated, transaction }) => {
  // Pre-fill paid checkbox and pass handler
  const initialValues = {
    paid: true,
    createdDate: transaction?.transactionDate ? dayjs(transaction.transactionDate) : undefined,
    claimantAmount: Math.abs(transaction?.amount || 0),
    supplierName: transaction?.description || '',
  };
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={700}
      destroyOnClose
      title="Create Expense/Bill for Transaction"
    >
      <RecordForm
        type="expense"
        showAllPurposes={false}
        onRecordAdded={onCreated}
        initialValues={initialValues}
        paidDisabled={true}
      />
    </Modal>
  );
};

export default CreateExpenseModal;
